// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uhRzB","name":"styles_name__2Ty11","phone":"styles_phone__3iciE"};